<payee-form-field
  [width]="width"
  [height]="height"
>
  <ng-content
    payee-label
    select="[payee-label]"
  ></ng-content>
  <input
    payee-input
    name="password"
    autocomplete="new-password"
    data-testid="password-input"
    [formControl]="formControl"
    [type]="showPassword() ? 'text' : 'password'"
    [placeholder]="placeholder"
    (blur)="onTouched()"
  />
  <ng-content
    error-icon
    select="[error-icon]"
  ></ng-content>
  @if (!showPassword()) {
    <button
      type="button"
      payee-suffix
      payee-icon-button
      style="pointer-events: all"
      color="white"
      (click)="showPassword.set(true)"
    >
      <img
        src="assets/shared/global-images/icon-set/eyes-on.svg"
        alt=""
      />
    </button>
  }
  @if (showPassword()) {
    <button
      type="button"
      payee-suffix
      payee-icon-button
      style="pointer-events: all"
      color="white"
      (click)="showPassword.set(false)"
    >
      <img
        src="assets/shared/global-images/icon-set/eyes-off.svg"
        alt=""
      />
    </button>
  }
  <ng-content
    payee-error
    select="[payee-error]"
  ></ng-content>
</payee-form-field>
